function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import * as ActionType from '../ActionType';
import * as CampaignAPI from '../../components/campaign/CampaignAPI';
import * as TapSurveyAPI from '../../api/TapSurveyAPI';
import * as QualificationAction from './Qualification';
export var initializeCampaign = function(campaignIdentifier) {
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var results, _results_data, countryId, languageId, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch({
                            type: ActionType.LOAD_CAMPAIGN_REQUEST
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            CampaignAPI.get(campaignIdentifier)
                        ];
                    case 2:
                        results = _state.sent();
                        dispatch({
                            type: ActionType.LOAD_CAMPAIGN_SUCCESS,
                            payload: {
                                campaign: results.data
                            }
                        });
                        dispatch(getTapSurvey(campaignIdentifier, results.data.providable.identifier));
                        _results_data = results.data, countryId = _results_data.country_id, languageId = _results_data.language_id;
                        dispatch(QualificationAction.getQualificationTopics(countryId, languageId));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        dispatch({
                            type: ActionType.LOAD_CAMPAIGN_FAILURE,
                            payload: {
                                error: e.message
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var getTapSurvey = function(campaignIdentifier, tapSurveyIdentifier) {
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var result, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch({
                            type: ActionType.LOAD_CAMPAIGN_TAP_SURVEY_REQUEST
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            TapSurveyAPI.get(tapSurveyIdentifier)
                        ];
                    case 2:
                        result = _state.sent();
                        dispatch({
                            type: ActionType.LOAD_CAMPAIGN_TAP_SURVEY_SUCCESS,
                            payload: {
                                tapSurvey: result.data,
                                campaignIdentifier: campaignIdentifier
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        dispatch({
                            type: ActionType.LOAD_CAMPAIGN_TAP_SURVEY_FAILURE,
                            payload: {
                                error: err.message
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var updateTapSurvey = function(campaignIdentifier, tapSurvey) {
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            return _ts_generator(this, function(_state) {
                dispatch({
                    type: ActionType.LOAD_CAMPAIGN_TAP_SURVEY_SUCCESS,
                    payload: {
                        tapSurvey: tapSurvey,
                        campaignIdentifier: campaignIdentifier
                    }
                });
                return [
                    2
                ];
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var updateCampaign = function(campaign) {
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            return _ts_generator(this, function(_state) {
                dispatch({
                    type: ActionType.LOAD_CAMPAIGN_SUCCESS,
                    payload: {
                        campaign: campaign
                    }
                });
                return [
                    2
                ];
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var fetchCampaign = function(campaignIdentifier) {
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var results, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch({
                            type: ActionType.LOAD_CAMPAIGN_REQUEST
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            CampaignAPI.get(campaignIdentifier)
                        ];
                    case 2:
                        results = _state.sent();
                        dispatch({
                            type: ActionType.LOAD_CAMPAIGN_SUCCESS,
                            payload: {
                                campaign: results.data
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        dispatch({
                            type: ActionType.LOAD_CAMPAIGN_FAILURE,
                            payload: {
                                error: e.message
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var resetCurrentCampaign = function() {
    return function(dispatch) {
        return dispatch({
            type: ActionType.RESET_CURRENT_CAMPAIGN
        });
    };
};
